import { EventTrade } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { EventTradeClientService } from '../../tools/helpers';
import { isTradeId } from '../../utils/eventTrade';
import { queryKeys } from './constants';

export const useEventTradesQuery = () => {
  return useQuery({
    queryKey: [queryKeys.eventTrades.root, queryKeys.eventTrades.list],
    queryFn: async () => {
      const req = EventTrade.create({ isActive: true, withoutLimit: true });
      const res = await EventTradeClientService.BatchGet(req);
      return res.results.filter((t) => isTradeId(t.id));
    },
    staleTime: 5 * 60 * 1000,
  });
};
